import React, { useEffect } from 'react';
import { Box, Grid, GridItem, Image } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { useTokens } from '../../../context/TokenProvider';
import PhotoGridItem from './PhotoGridItem';
import { RenderIf } from '../RenderIf/RenderIf';
import { localise } from '../../../services/lang/lang';
import MediaViewer from '../MediaViewer/MediaViewer';
import useStyling from '../../../hooks/useStyling';
import { clearUploadedCache } from '../../../actions/documents';
const MAX_PHOTOS = 4;
const PhotoGrid = ({ finding, shouldLoadPhotos, loadedPhotos, isShare = false, }) => {
    const dispatch = useDispatch();
    const tokens = useTokens();
    const { photos } = finding;
    const { cache } = useSelector((state) => state.models.photo.uploaded);
    const { photoGrid: styles } = useStyling();
    const hasMultiplePhotos = photos.length > 1;
    const columns = hasMultiplePhotos ? 2 : 1;
    const displayedPhotos = photos.slice(0, MAX_PHOTOS);
    useEffect(() => () => {
        photos.forEach((photo) => {
            const cachePhoto = cache?.[photo.id];
            if (cachePhoto) {
                URL.revokeObjectURL(cachePhoto);
            }
        });
        dispatch(clearUploadedCache());
    }, []);
    return (React.createElement(MediaViewer, { isShare: isShare, allMedia: photos, loadedPhotos: loadedPhotos }, ({ onMediaClick, onMediaKeyDown, onOpenAtStart }) => (React.createElement(Grid, { templateColumns: `repeat(${columns}, 1fr)`, gap: tokens.Spacing04, sx: styles, "data-testid": "photo-grid" },
        displayedPhotos.map((photo, index) => {
            const cachePhoto = cache?.[photo.id];
            const loadedPhoto = loadedPhotos?.find((p) => p.id === photo.id) ??
                (cachePhoto
                    ? {
                        id: photo.id,
                        url: cachePhoto,
                    }
                    : undefined);
            return (React.createElement(GridItem, { key: photo.id },
                React.createElement(Box, { "data-testid": "photo-grid-item", "aria-label": localise('IMAGE_THUMBNAIL'), sx: styles.thumbnail },
                    React.createElement(PhotoGridItem, { photo: photo, shouldLoad: !loadedPhoto && !!shouldLoadPhotos, maxToShow: MAX_PHOTOS, canShowBadge: index === MAX_PHOTOS - 1, photoCount: photos.length, shouldIncreaseSize: true, loadedPhoto: loadedPhoto, clickHandler: () => onMediaClick(photo), keyDownHandler: (e) => onMediaKeyDown(e, photo), onOpenAtStart: onOpenAtStart, isShare: isShare }))));
        }),
        React.createElement(RenderIf, { condition: photos.length === 0 },
            React.createElement(GridItem, { "data-testid": "photo-grid-item__no-photos" },
                React.createElement(Image, { src: "/images/no-photo-medium.svg", alt: localise('NO_PHOTOS_ADDED'), w: "228px", h: "228px" })))))));
};
export default React.memo(PhotoGrid);
